import "../../../assets/scss/components/sections/home/benefits.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import { Container, Image } from "react-bootstrap";
import Heading from "../../templates/heading";

import check from "../../../assets/images/home/benefits-check.svg";
import img1 from "../../../assets/images/home/benefits-1.png";
import Btn from "../../templates/button";

import shape1 from "../../../assets/images/home/shape-2.svg";
import shape2 from "../../../assets/images/home/shape-3.svg";

import { Player } from "@lottiefiles/react-lottie-player";
import animationData from "../../../assets/animations/Lottie Transparent BG Compressed R2.json";

const Benefit = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true, // Show next/prev
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const data = [
    {
      heading: "Apply 10x Faster",
      paragraph: "Generate tailored resumes in seconds and apply effortlessly",
    },
    {
      heading: "Land More Interviews",
      paragraph: "Boost your interview rate by applying to more jobs with ease",
    },
    {
      heading: "Save Time & Energy",
      paragraph: "Forget spending hours—get an optimized resume in 60 seconds",
    },
    {
      heading: "AI-Powered Tracking",
      paragraph: "Measure resume success with AI-driven insights",
    },
    {
      heading: "One-Click Resume Tailoring",
      paragraph:
        "Paste a job URL, and let Resumly.AI tailor your resume instantly",
    },
  ];
  return (
    <div className="benefit-section">
      <Container>
        <div className="benefit">
          <Heading
            heading="Why should you use Resumly?"
            text="Make your job search more effective"
          />
          <div className="content d-flex">
            <div className="left">
              <div className="benefits-list">
                {data.map((d, i) => (
                  <div className="list-item">
                    <div className="d-flex align-items-center list-item-heading">
                      <div className="check">
                        <Image src={check} />
                      </div>
                      <h6 className="heading-6">{d.heading}</h6>
                    </div>
                    <p className="paragraph-small-regular">{d.paragraph}</p>
                  </div>
                ))}
              </div>
              <Slider {...sliderSettings} className="benefits-slider">
                {data.map((d, i) => (
                  <div className="list-item" key={i}>
                    <div className="d-flex align-items-center list-item-heading">
                      <div className="check">
                        <Image src={check} alt="Check icon" />
                      </div>
                      <h6 className="heading-6">{d.heading}</h6>
                    </div>
                    <p className="paragraph-small-regular">{d.paragraph}</p>
                  </div>
                ))}
              </Slider>
              <div className="text-center text-lg-start">
                <Btn
                  text="Try It Now"
                  class="btn-secondary"
                  handle={() => {
                    window.location.href =
                      process.env.REACT_APP_APP_REGISTER_URL;
                  }}
                />
              </div>
            </div>
            <div className="right">
              {/*<div className="animation">*/}
              {/*  <Player autoplay loop src={animationData} />*/}
              {/*</div>*/}
            </div>

            <div className="shape-2 shape">
              <Image src={shape2} />
            </div>
          </div>
        </div>
      </Container>
      <div className="shape-1 shape">
        <Image src={shape1} />
      </div>
    </div>
  );
};

export default Benefit;
